import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HomeCover() {
  const images = [
    'https://placehold.co/400x500/1e293b/d4b68f?text=PREMIUM',
    'https://placehold.co/400x500/1e293b/d4b68f?text=MODERN',
    'https://placehold.co/400x500/1e293b/d4b68f?text=CLASSIC',
  ];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);

  // --- NEW: Mouse tracking state for Tom & Jerry ---
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth) * 2 - 1;
      const y = (e.clientY / window.innerHeight) * 2 - 1;
      setMousePos({ x, y });
      setRotation({ x: x * 20, y: y * 10 });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);
  // ------------------------------------------------

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  useEffect(() => {
    const animationTimeout = setTimeout(() => {
      setHasAnimated(true);
    }, 500);

    return () => clearTimeout(animationTimeout);
  }, []);

  const mainContainerStyle = {
    position: 'relative',
    width: '100%',
    minHeight: '100vh', 
    paddingTop: '90px', 
    backgroundColor: '#ffffff',
    overflow: 'hidden',
    fontFamily: 'sans-serif',
    color: '#0f172a',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box'
  };

  const blobStyle1 = {
    position: 'absolute',
    top: '25%',
    left: '25%',
    width: '10rem',
    height: '10rem',
    backgroundColor: '#f43f5e',
    borderRadius: '9999px',
    mixBlendMode: 'multiply',
    filter: 'blur(48px)',
    animation: 'blob1 15s infinite ease-in-out',
    opacity: '0.2',
  };

  const blobStyle2 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '15rem',
    height: '15rem',
    backgroundColor: '#facc15',
    borderRadius: '9999px',
    mixBlendMode: 'multiply',
    filter: 'blur(48px)',
    animation: 'blob2 18s infinite ease-in-out reverse',
    opacity: '0.2',
  };

  const blobStyle3 = {
    position: 'absolute',
    top: '75%',
    left: '33.3333%',
    width: '13rem',
    height: '13rem',
    backgroundColor: '#38bdf8',
    borderRadius: '9999px',
    mixBlendMode: 'multiply',
    filter: 'blur(48px)',
    animation: 'blob3 12s infinite ease-in-out',
    opacity: '0.2',
  };

  const heroContentStyle = {
    position: 'relative',
    zIndex: '10',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1', 
    padding: '2rem 1rem',
  };

  const contentGridStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    width: '100%',
    maxWidth: '80rem',
  };

  const textContainerStyle = {
    flex: '1',
    textAlign: 'center',
    padding: '1rem',
  };

  const headingStyle = {
    fontFamily: 'serif',
    fontSize: '3rem',
    fontWeight: 'bold',
    color: '#0f172a',
    backgroundImage: 'none',
    animation: 'fadeInUp 1s ease-out forwards',
    position: 'relative',
    display: 'inline-block',
    paddingBottom: '1rem',
  };

  const subheadingStyle = {
    marginTop: '1.5rem',
    fontSize: '1.25rem',
    fontWeight: '500',
    color: '#334155',
    animation: 'fadeInUp 1s ease-out forwards',
    animationDelay: '0.3s',
  };

  const paragraphStyle = {
    marginTop: '1rem',
    fontSize: '0.875rem',
    color: '#475569',
    maxWidth: '32rem',
    marginLeft: 'auto',
    marginRight: 'auto',
    animation: 'fadeInUp 1s ease-out forwards',
    animationDelay: '0.6s',
  };

  const imagesContainerStyle = {
    flex: '1',
    position: 'relative',
    width: '100%',
    height: '20rem',
    marginTop: '2.5rem',
  };

  const imageWrapperStyle = {
    position: 'relative',
    width: '100%',
    height: '100%',
    borderRadius: '1rem',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    overflow: 'hidden',
    transform: 'rotate(6deg) scale(0.95)',
    transition: 'transform 500ms ease-in-out',
  };

  const imageStyle = (index) => ({
    position: 'absolute',
    inset: '0',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '1rem',
    transition: 'opacity 1000ms ease-in-out',
    opacity: index === currentImageIndex ? '1' : '0',
  });
  
  const smallLineStyle = {
    position: 'relative',
    display: 'block',
    margin: '10px auto 0',
    width: '60px',
    height: '3px',
    borderRadius: '1.5px',
    backgroundColor: '#ff8c00',
    transform: hasAnimated ? 'scaleX(1)' : 'scaleX(0)',
    transformOrigin: 'center',
    transition: 'transform 1s ease-out',
  };

  const [isHovered, setIsHovered] = useState(false);

  const buttonContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '2rem',
    position: 'relative', 
    zIndex: '30',
  };

  const buttonLinkStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    backgroundColor: isHovered ? '#111827' : '#1f2937',
    color: '#ffffff',
    borderRadius: '9999px',
    fontWeight: '500',
    padding: '0.75rem 1.5rem',
    textDecoration: 'none',
    transition: 'all 0.3s ease-in-out',
    transform: isHovered ? 'scale(1.05)' : 'scale(1)',
  };

  const buttonSpanStyle = {
    display: 'inline-block',
    transform: isHovered ? 'translateX(4px)' : 'translateX(0)',
    transition: 'transform 0.3s ease-in-out',
  };

  // --- NEW: Face styles ---
  const tomHeadStyle = { transform: `rotate(${rotation.x}deg) translateY(${mousePos.y * 5}px)` };
  const jerryHeadStyle = { transform: `rotate(${rotation.x * 1.5}deg) translateY(${mousePos.y * 8}px)` };
  const pupilStyle = { transform: `translate(${mousePos.x * 8}px, ${mousePos.y * 8}px)` };

  return (
    <div style={mainContainerStyle}>
      <div style={{ position: 'absolute', inset: '0', zIndex: '0', opacity: '0.2' }}>
        <div style={blobStyle1}></div>
        <div style={blobStyle2}></div>
        <div style={blobStyle3}></div>
      </div>

      <div style={heroContentStyle}>
        <div style={contentGridStyle}>
          <div style={textContainerStyle}>
            <h1 style={headingStyle}>
              Welcome to Girraj Technology
            </h1>
            <span style={smallLineStyle}></span>
            <h2 style={subheadingStyle}>
              Innovating Your Business with Technology
            </h2>
            <p style={paragraphStyle}>
              We provide cutting-edge solutions for future-thinking businesses, helping you stay ahead in a rapidly changing world.
            </p>
          </div>

          <div style={buttonContainerStyle}>
            <Link
              to="/AI"
              style={buttonLinkStyle}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <span>Know Your Online Business Budget</span>
              <span style={buttonSpanStyle}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ height: '1.5rem', width: '1.5rem' }}
                >
                  <path d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </span>
            </Link>
          </div>

          <div style={imagesContainerStyle}>
            <div style={imageWrapperStyle}>
              {images.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Slide ${index + 1}`}
                  style={imageStyle(index)}
                />
              ))}
            </div>
          </div>
        </div>

        {/* --- NEW: Interactive Responsive Faces --- */}
        <div className="cartoon-container">
          <div className="char-box" style={tomHeadStyle}>
            <div className="tom-face">
              <div className="ear-l"></div><div className="ear-r"></div>
              <div className="eye-l"><div className="pupil" style={pupilStyle}></div></div>
              <div className="eye-r"><div className="pupil" style={pupilStyle}></div></div>
              <div className="nose"></div>
            </div>
          </div>
          <div className="char-box" style={jerryHeadStyle}>
            <div className="jerry-face">
              <div className="j-ear-l"></div><div className="j-ear-r"></div>
              <div className="j-eye-l"><div className="j-pupil" style={pupilStyle}></div></div>
              <div className="j-eye-r"><div className="j-pupil" style={pupilStyle}></div></div>
              <div className="j-nose"></div>
            </div>
          </div>
        </div>

        <div style={{ position: 'relative', width: '100%', zIndex: '20', marginTop: 'auto' }}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" style={{ width: '100%', height: 'auto', display: 'block', pointerEvents: 'none' }}>
            <path fill="#0f172a" fillOpacity="1" d="M0,288L60,266.7C120,245,240,203,360,208C480,213,600,267,720,282.7C840,299,960,277,1080,272C1200,267,1320,277,1380,282.7L1440,288L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path>
          </svg>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes blob1 {
          0% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(25px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0, 0) scale(1); }
        }
        @keyframes blob2 {
          0% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(-40px, 10px) scale(0.95); }
          66% { transform: translate(30px, -30px) scale(1.05); }
          100% { transform: translate(0, 0) scale(1); }
        }
        @keyframes blob3 {
          0% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(15px, 25px) scale(1.1); }
          66% { transform: translate(-35px, -15px) scale(0.9); }
          100% { transform: translate(0, 0) scale(1); }
        }
        @media (max-width: 768px) {
          h1 { font-size: 2.2rem !important; }
          .cartoon-container {
            gap: 30vw !important;
            margin-bottom: -10px !important; /* Adjusted for mobile view visibility */
          }
        }

        /* --- Cartoon CSS --- */
        .cartoon-container {
          display: flex; 
          justify-content: center; 
          align-items: flex-end;
          gap: clamp(60px, 15vw, 200px); 
          width: 100%; 
          height: 100px;
          margin-bottom: -45px; /* Pulls faces slightly into the wave */
          z-index: 25;
          position: relative;
        }
        .char-box { position: relative; transition: transform 0.1s ease-out; transform-origin: bottom center; }
        .tom-face {
          width: clamp(65px, 10vw, 100px); height: clamp(55px, 9vw, 90px);
          background: linear-gradient(145deg, #708090, #4a5560);
          border-radius: 50% 50% 45% 45%; position: relative;
        }
        .jerry-face {
          width: clamp(50px, 8vw, 80px); height: clamp(40px, 7vw, 70px);
          background: linear-gradient(145deg, #a0522d, #7a3e22);
          border-radius: 50%; position: relative;
        }
        .eye-l, .eye-r, .j-eye-l, .j-eye-r {
          position: absolute; top: 22%; width: 25%; height: 35%;
          background: white; border-radius: 50%; overflow: hidden; border: 1px solid #333;
        }
        .eye-l, .j-eye-l { left: 18%; } .eye-r, .j-eye-r { right: 18%; }
        .pupil, .j-pupil { 
          background: #000; width: 45%; height: 50%; border-radius: 50%; 
          position: absolute; left: 25%; top: 25%; 
        }
        .nose, .j-nose {
          position: absolute; top: 60%; left: 42%; width: 16%; height: 12%;
          background: #ffb6c1; border-radius: 50%;
        }
        .j-nose { background: #333; }
        .ear-l, .ear-r, .j-ear-l, .j-ear-r {
          position: absolute; top: -15%; width: 40%; height: 45%;
          background: inherit; border-radius: 50% 50% 0 0; z-index: -1;
        }
        .ear-l { left: -5%; transform: rotate(-20deg); } .ear-r { right: -5%; transform: rotate(20deg); }
        .j-ear-l { left: -20%; border-radius: 50%; } .j-ear-r { right: -20%; border-radius: 50%; }
      `}</style>
    </div>
  );
}